import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersQuestionAnswerMutateType } from "~/domains";

type RequestDataType = {
  questionAnswerCategoryId: string;
  body: {
    questionContent: string;
    answerContent: string;
    link?: string;
    displayOrder: number;
    tagNames: string[];
  };
};

const request = ({ questionAnswerCategoryId, body }: RequestDataType) => {
  return new ApiClient()
    .post<ApiManagersQuestionAnswerMutateType>(
      `/api/managers/question_answer_categories/${questionAnswerCategoryId}/question_answers`,
      {
        questionAnswer: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersQuestionAnswerCategoriesQuestionAnswersCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersQuestionAnswerMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
